import type { SagaMiddleware, Saga, Task } from 'redux-saga';
import { cancel, fork, join, take } from 'redux-saga/effects';
import type { AppStore } from '../Redux';

export const CANCEL_SAGAS_HMR = '@@saga_manager/CANCEL_SAGAS_HMR';

// Borrowed from https://gist.github.com/hoschi/6538249ad079116840825e20c48f1690
// Note that reloading sagas has several issues/caveats to be aware of.
// See https://github.com/yelouafi/redux-saga/issues/22#issuecomment-218737951 for discussion.
function createAbortAbleSaga(saga: Saga, hot: boolean) {
  return function* main() {
    while (true) {
      try {
        const sagaTask: Task = yield fork(saga, hot);

        if (import.meta.env.MODE === 'development') {
          yield take(CANCEL_SAGAS_HMR);
          yield cancel(sagaTask);
          break; // cancelled, break out of the loop
        } else {
          yield join(sagaTask);
        }
      } catch (err) {
        // Log the error and trap it, allowing the saga to be restarted
        if (import.meta.env.MODE === 'development') {
          console.warn('Saga crashed', saga.name, err);
        }
      }
    }
  };
}

const SagaManager = {
  run(sagaMiddleware: SagaMiddleware<object>, sagas: Saga[], hot: boolean = false) {
    if (import.meta.env.MODE === 'development') {
      console.log('DEBUG: Starting sagas');
    }

    sagas
      .map((saga) => createAbortAbleSaga(saga, hot))
      .forEach((saga) => {
        sagaMiddleware.run(saga);
      });
  },

  cancel(store: AppStore) {
    store.dispatch({
      type: CANCEL_SAGAS_HMR,
    });
  },
};

export default SagaManager;
